<template>
  <div class="aviation-navbar">
      <div class="toplogo">
         <img class="mainlogo" src="../assets/logoSar.png">
         <img class="logosar" src="../assets/sar.png">
    </div>
    <nav class="navbar is-black">
        <!-- <div class="container"> -->
            <div class="navbar-brand">
                <div class="navbar-burger burger" @click="navbarBurger" data-target="navMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div id="navMenu" class="navbar-menu">
                <div class="navbar-start">
                    <a v-show="$route.path!=='/' " class="navbar-item" >
                     <router-link to="/">
                      About Us
                     </router-link>
                    </a>
                    
                    <a v-show="$route.path!=='/contact'" class="navbar-item"  >
                      <router-link to="/contact">
                      Contact Us
                      </router-link>
                    </a>
                    <a class="navbar-item" >
                      <!-- <router-link to="/construction/projects"> -->
                      Projects
                      <!-- </router-link> -->
                    </a>
                    
                </div>

            <!-- </div> -->
        </div>
    </nav>

    <!--NAVBAR END-->

  </div>
</template>

<script>
export default {
  data:function(){
    return{
      navbarState:false
    }
  },
  methods:{
    navbarBurger(){
      this.navbarState=true
      console.log(this.navbarState)
          var burger = document.querySelector('.burger');
          var menu = document.querySelector('#'+burger.dataset.target);
          burger.classList.toggle('is-active')
          menu.classList.toggle('is-active')
    }
  }
}
</script>


<style>

@media only screen and (max-width: 600px) {
    .navbar {
    margin-left: 10px;
    margin-right: 10px;
    }

    nav.navbar {
      border-top: 2px solid #000000;
      margin-bottom: 1rem;
      color: white
    }
}

@media only screen and (min-width: 700px) {
    .navbar {
    margin-left: 30px;
    margin-right: 30px;
    }
}



nav.navbar {
  border-top: 2px solid #000000;
  margin-bottom: 1rem;
  color: white
}


.navbar-item.brand-text {
  font-weight: 300;
  text-align: center
}

.navbar-item, .navbar-link {
  font-size: 14px;
  font-weight: 700;
  color: white;
}

a {
    color: white;
    cursor: pointer;
    text-decoration: none;
} 
    


#navMenu{
  background-color: black
}



</style>
